import { createRoot, hydrateRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { RootLayout } from "./components/RootLayout";
import { routes as ssgRoutes } from "./routes.ssg";
import NotFound from "./pages/NotFound";
import App from "./App.tsx";
import "./index.css";

const rootElement = document.getElementById("root")!;

if (rootElement.hasChildNodes()) {
  // Hydrate SSG-rendered pages using the same tree structure as main.ssg.tsx
  // This prevents React errors #418/#423 caused by tree mismatches
  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      children: [
        ...ssgRoutes.map((r) => ({
          index: r.index,
          path: r.path,
          Component: r.Component,
        })),
        { path: "*", Component: NotFound },
      ],
    },
  ]);

  hydrateRoot(rootElement, <RouterProvider router={router} />);
} else {
  // Dev mode — use the full App with lazy loading
  createRoot(rootElement).render(<App />);
}
